import {Ref} from "react"
import styles from "./DailyAttendanceCheckInCheckOutReport.module.css"
import CheckInCheckOutView from "./CheckInCheckOutView"
import {CheckInCheckOutStudent} from "./checkInCheckOutReport"

type Props = {
    pdfRef?: Ref<HTMLDivElement>
    downloading?: boolean
    logoBase64?: string
    collegeName?: string
    dateLabel: string
    campuses?: string[]
    programs?: string[]
    phases?: string[]
    shifts?: string[]
    students: CheckInCheckOutStudent[]
    timeFormat: string
    dateFormat?: string
    isLoading?: boolean
}

const CheckInCheckOutPdfPage = ({
    pdfRef,
    downloading,
    logoBase64,
    collegeName,
    dateLabel,
    campuses = [],
    programs = [],
    phases = [],
    shifts = [],
    students,
    timeFormat,
    dateFormat,
    isLoading = false
}: Props) => {
    return (
        <div ref={pdfRef} className={styles.pdfPage} style={!downloading ? {paddingTop: 40} : {paddingTop: 0}}>
            <div className={styles.rowTitle}>
                <div className={styles.logoContainer}>
                    <img className={styles.logo} alt="logo" src={logoBase64} />
                </div>
                <div className={styles.reportTitleBlock}>
                    <h2 className={styles.reportCollegeName}>{collegeName}</h2>
                    <h2 className={styles.reportTitle}>DAILY ATTENDANCE CHECK-IN / CHECK-OUT REPORT</h2>
                    <h4 className={styles.reportMeta} style={{marginTop: 0}}>
                        Date: {dateLabel}
                    </h4>
                    {campuses.length > 0 ? (
                        <h4 className={styles.reportMeta}>
                            {campuses.length > 1 ? "Campuses" : "Campus"}: {campuses.join(", ")}
                        </h4>
                    ) : null}
                    {programs.length > 0 ? (
                        <h4 className={styles.reportMeta}>
                            {programs.length > 1 ? "Programs" : "Program"}: {programs.join(", ")}
                        </h4>
                    ) : null}
                    {phases.length > 0 ? (
                        <h4 className={styles.reportMeta} style={{maxWidth: "400px"}}>
                            {phases.length > 1 ? "Phases" : "Phase"}: {phases.join(", ")}
                        </h4>
                    ) : null}
                    {shifts.length > 0 ? (
                        <h4 className={styles.reportMeta} style={{maxWidth: "400px"}}>
                            {shifts.length > 1 ? "Shifts" : "Shift"}: {shifts.join(", ")}
                        </h4>
                    ) : null}
                </div>
                <div className={styles.headerSpacer} />
            </div>

            <CheckInCheckOutView
                isLoading={isLoading}
                students={students}
                timeFormat={timeFormat}
                dateFormat={dateFormat}
            />
        </div>
    )
}

export default CheckInCheckOutPdfPage
